<template>
    <div class="news-block">
        <div class="news-img news-img-1" v-if="bg1">
        </div>
        <div class="news-img news-img-2" v-else>
        </div>
        <div class="news-type">
            <img :src="logoUrl"/>
        </div>
        <!-- <div class="news-line"></div> -->
        <div class="news-list" >
            <NewsItemList  v-for="item in newsData.content" :key="item.contentId"  :content="item"/>
        </div>
        <div class="news-pager">
            <Pager  :total="newsData.totalPages" :allPage="newsData.numberOfElements" v-on:change="changePage"></Pager>
        </div>
        
    </div>
</template>

<script>

import NewsItemList from "../components/NewsItemList"

import Pager from "../components/Pager"
export default {
    name:'NewsList',
    components:{NewsItemList, Pager},
    data(){
        return {
            newsData :[],
            columnId:'',
            pageNo:1,
            pageSize:20,
            logoUrl:'',
            bg1:true
        }
    },
    created(){
        this.columnId = this.$route.query.columnId;
        if(!this.$route.query.columnId){
            MessageBox.alert("缺少参数 columnId");
            return;
        }
        if(this.columnId == "CLNEWS"){
            this.bg1 = false;
        }else{
            this.bg1 = true;
        }
    },
    mounted(){
        this.getColumn();
        this.getNews();
    },
    methods:{
        getNews(){
            const self = this;
            this.$http.get("/bicycle/inter/newsList?pageNo="+this.pageNo+"&pageSize="+this.pageSize+"&columnId=" + this.columnId + "&isTop=true").then(function(res){
                if(res.data.status != 200){
                    MessageBox.alert(res.data.errorMsg);
                }else{
                    self.newsData = res.data.data;
                }
            
            }).catch(function(error){
                console.log(error);
            });
        },
        getColumn(){
            const self = this;
            this.$http.get("/bicycle/inter/columnInfo?columnId=" + this.columnId).then(function(res){
                if(res.data.status != 200){
                    MessageBox.alert(res.data.errorMsg);
                }else{
                    self.logoUrl = res.data.data.imageUrl;
                }
            
            }).catch(function(error){
                console.log(error);
            });
        },
        changePage(page){
            this.pageNo = page;
            this.getNews();
        }
    }
}
</script>

<style scoped>
.news-block{
    width: 1200px;
    margin: 0 auto;
    margin-top: 60px;
    margin-bottom: 60px;
}
.news-type{
    text-align: center;
    margin-top: 89px;
    margin-bottom: 82px;
}
.news-line{
    margin-top: 18px;
    margin-bottom: 18px;
    width: 970px;
    margin-left: auto;
    margin-right: auto;
    border-top: 2px dashed #2E3855;
}
.news-list{
    justify-content: flex-start;
    display: flex;
    align-items: baseline;
    flex-flow: row wrap;
}
.news-pager{
    text-align: center;
    margin-top: 40px;
    position: relative;
}
.news-img{
    position: absolute;
    width: 100%;
    left: 0;
    right: 0;
    bottom: 593px;
    max-width: 1920px;
    min-width: 1200px;
    background: url('/abc/static/news_1.png') no-repeat 100% 100%;
    background-size: contain;
    height: 500px;
}
.news-img-1{
background: url('/abc/static/news_1.png') no-repeat 100% 100%;
}
.news-img-2{
background: url('/abc/static/news_2.png') no-repeat 100% 100%;
}

</style>


// WEBPACK FOOTER //
// src/pages/NewsList.vue